// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3W5ea","alert":"SettungsInbox_alert__1E5f0"};